import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmationDialogComponent } from '../../components/confirmation-dialog/confirmation-dialog.component';

/**
 * Service to show unsaved changes confirmation dialog
 */
@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesDialogService {
  constructor(private dialog: MatDialog) {}

  showConfirmation(
    message: string = 'Your progress or changes will not be saved if you move away. Do you want to continue?',
    title: string = 'Unsaved Changes',
    confirmText: string = 'Yes',
    cancelText: string = 'No'
  ): Observable<boolean> {
    return new Observable((observer) => {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '400px',
        disableClose: true,
        data: {
          title,
          message,
          confirmText,
          cancelText
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        observer.next(result === true);
        observer.complete();
      });
    });
  }
}
